module.exports = __webpack_public_path__ + "static/the-constant-princess-2d24ad64210ca4e4f8fe665e4be5802d.jpg";